module.exports = __webpack_public_path__ + "img/BANX.a385a696.svg";